import { useEffect, useRef, useState } from "react";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import translateText, { currentLanguage } from "../signals/language.signal";

import { useNavigate } from "react-router-dom";
import { sendOTP } from "../signals/otp.signal";
import SideBar from "../components/sideBar";
import { logClientMobileNumber } from "../signals/login.signal";
import { Alert, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Form } from "react-bootstrap";

const OTPPage = () => {
  const [loading, setLoading] = useState(false);
  const [requestDisabled, setRequestDisabled] = useState(true);
  const [validated, setValidated] = useState(true);
  const generateOtpRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const showAlertMessage = (MSG) => {
    setAlertMessage(MSG);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };

  const inputsRef = useRef([]);
  const length = 4;

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;
    e.target.value = value;
    if (value && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }

    console.log(generateOtpRef);
    const otp = inputsRef.current.map((input) => input.value).join("");
    console.log(otp);
    if (otp.length === length && otp === String(generateOtpRef.current)) {
      navigate("/home");
    } else if (otp.length === length) {
      showAlertMessage("erorr");
      setValidated(false);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  function startTwoMinuteTimer() {
    let timeLeft = 120; // in seconds

    const timer = setInterval(() => {
      // const minutes = Math.floor(timeLeft / 60);
      // const seconds = timeLeft % 60;

      // console.log(`Time left: ${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);

      if (timeLeft === 0) {
        clearInterval(timer);
        setRequestDisabled(false);
      }

      timeLeft--;
    }, 1000);
  }

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    const otp = inputsRef.current.map((input) => input.value).join("");
    if (otp.length === length && otp === String(generateOtpRef.current)) {
      navigate("/home");
    } else if (otp.length === length) {
      showAlertMessage("erorr");
      setValidated(false);
    }
    setValidated(true);
  };

  useEffect(() => {
    const sentOtp = async () => {
      setRequestDisabled(true);

      const nweOtp = Math.floor(1000 + Math.random() * 9000);
      generateOtpRef.current = nweOtp;
      try {
        const result = await sendOTP(
          "966" + logClientMobileNumber.value,
          generateOtpRef.current
        );
        startTwoMinuteTimer();
        console.log("966" + logClientMobileNumber.value);

        console.log(result);
        console.log(generateOtpRef.current);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    sentOtp();
  }, []);
  const navigate = useNavigate();
  return (
    <div
      className="position-absolute top-0 w-100"
      style={{ background: "#fff" }}
    >
      <SideBar
        more={true}
        back={true}
        backFunction={() => {
          navigate(-1);
        }}
        title={translateText(currentLanguage.value, "verifyPhone")}
      />

      <div className="align-items-sm-center d-flex justify-content-center w-100  position-absolute">
        <div className="loginContaner loginForm  mt-5 mt-sm-0  p-3 p-md-5 w-100  d-flex justify-content-center align-items-center flex-column">
          <p className="mb-5">
            {translateText(currentLanguage.value, "verifyText")}{" "}
            {logClientMobileNumber.value}
          </p>
          <Collapse
            in={open}
            className="pe-3 ps-3 w-100"
            // style={{ zIndex: 1000, direction: "ltr", top: 0 }}
          >
            <Alert
              severity="error"
              variant="filled"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  className="m-0"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" className="m-0" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              {alertMessage}
            </Alert>
          </Collapse>
          <Form noValidate onSubmit={handleSubmit}>
            <div className="d-flex gap-3 m-3 ">
              {Array.from({ length }).map((_, index) => (
                <input
                  key={index}
                  type="number"
                  maxLength="1"
                  className="form-control shadow rounded-3 text-center  "
                  style={{
                    height: "50px",
                    width: "50px",
                    border: `1px solid  ${validated ? "gray" : "red"}`,
                  }}
                  ref={(el) => (inputsRef.current[index] = el)}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>
            <p>
              {translateText(currentLanguage.value, "verifyResent")}{" "}
              <a
                onClick={() => {
                  requestDisabled ? null : sentOtp();
                }}
                disabled={requestDisabled}
                style={{ color: requestDisabled ? "gray" : primary.value }}
              >
                {translateText(currentLanguage.value, "verifyResentbtn")}
              </a>
            </p>

            <button
              type="submit"
              className="btn border btn-primary pe-3 ps-3 w-100 "
              style={{ background: primary.value, color: primaryFount.value }}
              // disabled={disabled}
            >
              {loading
                ? translateText(currentLanguage.value, "Loading") + "..."
                : translateText(currentLanguage.value, "Verify")}
            </button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default OTPPage;
